import React, { useState } from "react";
import FilterChartSystem from "../components/FilterChartSystem";
import { useAuth } from "../context/AuthContext";
import CompareAgents from "../components/CompareAgents";

export default function Dashboard() {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState("agents_statistics");

    // Show for both owner and manager
    if (user?.role !== "owner" && user?.role !== "manager") {
        return null;
    }

    return (
        <>
            <div className="mb-4 border-b border-gray-200">
                <nav className="flex -mb-px">
                    <button
                        onClick={() => setActiveTab("agents_statistics")}
                        className={`py-2 px-4 font-medium text-sm ${
                            activeTab === "agents_statistics"
                                ? "border-b-2 border-blue-500 text-blue-600"
                                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        Statistika agentov
                    </button>
                    <button
                        onClick={() => setActiveTab("compare_agents")}
                        className={`ml-8 py-2 px-4 font-medium text-sm ${
                            activeTab === "compare_agents"
                                ? "border-b-2 border-blue-500 text-blue-600"
                                : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        }`}
                    >
                        Primerjava agentov
                    </button>
                </nav>
            </div>
            {activeTab === "agents_statistics" && <FilterChartSystem />}
            {activeTab === "compare_agents" && <CompareAgents />}
        </>
    );
}
